// Shared types for the inbox surface. Lifted out of inbox/index.tsx so
// future inbox sub-components (composer, attachments picker) can import
// the same shapes without reaching across route files.

export type FilterValue = 'all' | 'unread' | 'active' | 'past';

export const FILTER_VALUES: ReadonlyArray<FilterValue> = [
  'all',
  'unread',
  'active',
  'past',
];

export type InboxSearch = {
  t?: string | undefined;
  f?: FilterValue | undefined;
};

export type InboxThread = {
  threadId: string;
  exchangeId: string;
  exchangeState: string;
  startDate: string;
  endDate: string;
  lastMessageAt: number;
  unreadCount: number;
  counterparty:
    | { kind: 'venue'; name: string; slug: string; venueId: string }
    | {
        kind: 'artist';
        name: string;
        slug: string | null;
        userId: string;
        // CFR-012: triage chips — only sent when the host is the viewer.
        artistVerified?: boolean;
        artistCompletedExchanges?: number;
        artistArtForms?: string[];
        artistAggregateAvg?: number | null;
        artistAggregateReviewCount?: number;
      };
  preview: {
    id: string;
    body: string;
    kind: 'user' | 'system_event';
    fromSelf: boolean;
    createdAt: number;
  } | null;
};

export type ThreadGroup = { label: string; items: InboxThread[] };
